import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
const FAQS = [{
  question: '¿Es material digital?',
  answer: 'Sí, es 100% digital. Recibís el acceso por email inmediatamente después de la compra. Podés leerlo desde tu celular, tablet o computadora en cualquier momento.'
}, {
  question: '¿Para qué edades sirve?',
  answer: 'El programa está diseñado específicamente para padres de niños de 2 a 12 años, abarcando las etapas críticas de desarrollo y formación de hábitos.'
}, {
  question: '¿Necesito experiencia previa?',
  answer: 'No. Está pensado para padres reales, con lenguaje sencillo y pasos claros. No necesitas ser experto en tecnología ni en pedagogía.'
}, {
  question: '¿Funciona si ya hay problemas?',
  answer: 'Sí, incluso si sentís que la situación está avanzada. Las estrategias incluyen técnicas para "desintoxicar" y restablecer límites aunque ya exista una dependencia fuerte.'
}];
export function FAQAccordion() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-16 bg-white px-4" data-id="element-126">
      <div className="max-w-2xl mx-auto" data-id="element-127">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-gray-900 mb-10" data-id="element-128">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-129">
          {FAQS.map((faq, index) => <div key={index} className="border border-gray-100 rounded-xl overflow-hidden bg-white hover:border-gray-200 transition-colors" data-id="element-130">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-5 text-left bg-white" data-id="element-131">
                <span className="font-semibold text-gray-900 text-lg" data-id="element-132">
                  {faq.question}
                </span>
                {openIndex === index ? <ChevronUp className="w-5 h-5 text-gray-400" data-id="element-133" /> : <ChevronDown className="w-5 h-5 text-gray-400" data-id="element-134" />}
              </button>

              {openIndex === index && <div className="p-5 pt-0 bg-white text-gray-600 leading-relaxed" data-id="element-135">
                  <div className="mt-2 text-base" data-id="element-136">{faq.answer}</div>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}